import React, { useEffect, useRef, useState } from 'react';

/* Zählt eine formatierte Zahl (z.B. "18%", "$8.325.000") beim Sichtbarwerden
   in ~1.1s von 0 hoch. Erhält Präfix/Suffix + deutsche Tausenderpunkte. */
export default function CountUp({ value, duration = 1100, delay = 700, className, ...rest }) {
  const ref = useRef(null);
  const [display, setDisplay] = useState(String(value));

  useEffect(() => {
    const raw = String(value);
    const m = raw.match(/^([^0-9]*)([\d.,]+)(.*)$/);
    if (!m) { setDisplay(raw); return undefined; }
    const [, pre, numStr, post] = m;
    const target = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(target)) { setDisplay(raw); return undefined; }
    const decimals = (numStr.split(',')[1] || '').length;
    const grouped = numStr.includes('.');
    const fmt = (n) => {
      let s = n.toFixed(decimals).replace('.', ',');
      if (grouped) {
        const [int, dec] = s.split(',');
        s = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? `,${dec}` : '');
      }
      return pre + s + post;
    };
    let raf = 0;
    let timer = 0;
    let started = false;
    const run = () => {
      const t0 = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        setDisplay(fmt(target * eased));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    };
    setDisplay(fmt(0));
    const el = ref.current;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started) {
          started = true;
          timer = setTimeout(run, delay);
          io.disconnect();
        }
      });
    }, { threshold: 0.35 });
    if (el) io.observe(el);
    return () => {
      io.disconnect();
      if (raf) cancelAnimationFrame(raf);
      if (timer) clearTimeout(timer);
    };
  }, [value, duration, delay]);

  return (
    <span ref={ref} className={className} {...rest}>
      {display}
    </span>
  );
}
